import getCharts from '../getCharts'
import { PhysicalExaminationData } from '../../constants/api.config'

export default async function PatientPhysicalExaminationData(mode,patientID = '-1',noteid="",typeofData="" ,jsonData="", id = '', ) {
    try {
        const payload = { mode, typeofData, jsonData, id, patientID ,jsonData,noteid}
        const res = await getCharts(PhysicalExaminationData, payload)
        return res.data
    } catch (error) {
        return error
    }
}
